import React, { useState } from 'react'
import { getFunctions, httpsCallable } from 'firebase/functions';
import DiscordTestModal from '../DiscordTestModal';

const NotificationsTab = ({ discordWebhook, setDiscordWebhook, notifyOption, setNotifyOption, name }) => {
    // Firebase Functions
    const functions = getFunctions();

    const [discordTestOpen, setDiscordTestOpen] = useState(false);
    const [discordTestStatus, setDiscordTestStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'
    const [discordTestMsg, setDiscordTestMsg] = useState('');

    // Discord Webhook 配信テスト
    const testDiscordWebhook = async () => {
        if (!discordWebhook) {
            setDiscordTestStatus('error');
            setDiscordTestMsg('Webhook URLが未設定です');
            setDiscordTestOpen(true);
            return;
        }
        setDiscordTestOpen(true);
        setDiscordTestStatus('sending');
        setDiscordTestMsg('送信しています...');
        try {
            const fn = httpsCallable(functions, 'testDiscordWebhook');
            const res = await fn({ webhook: discordWebhook, gameName: name || 'MetroTag' });
            if (res?.data?.status === 200 || res?.data?.message === 'ok') {
                setDiscordTestStatus('success');
                setDiscordTestMsg('Discordにテスト通知を送信しました');
            } else {
                setDiscordTestStatus('error');
                const serverMsg = res?.data?.message;
                setDiscordTestMsg(serverMsg ? `失敗: ${serverMsg}` : 'Discord Webhookの送信に失敗しました');
            }
        } catch (e) {
            console.error(e);
            setDiscordTestStatus('error');
            setDiscordTestMsg(e?.message ? `失敗: ${e.message}` : 'Discord Webhookの送信に失敗しました');
        }
    };

    return (
        <>
            <div className='lg:grid lg:grid-cols-2'>
                <div className='mb-6 mx-3'>
                    <div className='rounded-lg bg-white p-3 mb-3 shadow-sm'>
                        <h3 className='text-lg text-gray-800 mb-1'>通知方法</h3>
                        <div className='m-2'>
                            <label><i className='bi bi-discord me-2'></i>Discord Webhook</label>
                            <input value={discordWebhook} onChange={(e) => setDiscordWebhook(e.target.value)} type="text" className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" placeholder='https://discord.com/api/webhooks/-----------' />
                        </div>

                        { discordWebhook && (
                            <div className='flex justify-end'>
                                <button type='button' className='text-purple-500 hover:underline' onClick={() => testDiscordWebhook()}>配信テスト</button>
                            </div>
                        )}
                    </div>
                </div>

                <div className='mb-6 mx-3 bg-white border rounded-lg p-3 shadow-sm'>
                    <h3 className='text-lg text-gray-800 mb-1'>通知項目</h3>
                    <p className='text-sm text-gray-600'>※ 自動実行のみで通知されます</p>

                    <div className='m-2'>
                        <input className='m-2 w-4 h-4 align-middle' type="checkbox" id="notifyCheck2" checked={notifyOption[0]} onChange={(e) => setNotifyOption(prev => [e.target.checked, prev[1]])} />
                        <label htmlFor='notifyCheck2' className='align-middle' >ミッションの発令</label>
                    </div>

                    <div className='m-2'>
                        <input className='m-2 w-4 h-4 align-middle' type="checkbox" id="notifyCheck3" checked={notifyOption[1]} onChange={(e) => setNotifyOption(prev => [prev[0], e.target.checked])} />
                        <label htmlFor='notifyCheck3' className='align-middle'>つかまえた・つかまった</label>
                    </div>
                </div>
            </div>

            {/* Discord 配信テストモーダル */}
            <DiscordTestModal
                isOpen={discordTestOpen}
                onClose={() => setDiscordTestOpen(false)}
                onRetry={testDiscordWebhook}
                status={discordTestStatus}
                message={discordTestMsg}
                webhook={discordWebhook}
            />
        </>
    )
}

export default NotificationsTab
